import React from "react";
import * as s from "./ManagersControl.styles";

const ManagersControl = (props) => {
  const { id, name, email, phoneNumber } = props;
  return (
    <s.ManagerContainer>
      <s.H1>{name}</s.H1>
      <s.Span>{email}</s.Span>
      <s.Span>{phoneNumber}</s.Span>
    </s.ManagerContainer>
  );
};

export default ManagersControl;
